import { createAction } from '@reduxjs/toolkit';

import { TabsState } from './state';

export const changeModeratorPanelTab = createAction<TabsState['moderatorPanel']>('tabs/changeModeratorPanelTab');
export const changeFlaggedViewTab = createAction<TabsState['flaggedView']>('tabs/changeFlaggedViewTab');
export const changeDeletedViewTab = createAction<TabsState['deletedView']>('tabs/changeDeletedViewTab');
